







































import { cityController, getCountries, getRegions } from '@/api/Address/address'
import { Country, Region } from '@/utils/interfaces'
import vRules from '@/utils/vRules'
import { defineComponent, Ref, ref } from '@vue/composition-api'
import Autocomplete from './Autocomplete.vue'
import CreateDialog from './CreateDialog.vue'

export default defineComponent({
  components: { Autocomplete, CreateDialog },
  setup: (_, { emit }) => {
    const model = ref(false)
    const loading = ref(false)
    const name = ref('')
    const country = ref({}) as Ref<Country>
    const region = ref({}) as Ref<Region>

    const onSuccess = async () => {
      try {
        loading.value = true
        const response = await cityController.createOrUpdateJson({
          name: name.value,
          country: country.value.id,
          display_name: `${country.value.name}, ${region.value.name}, ${name.value}`,
          region: region.value.id,
        })
        emit('new-city', response.data)
        model.value = false
      } finally {
        loading.value = false
      }
    }

    return {
      name,
      country,
      region,
      loading,
      model,
      onSuccess,
      vRules,
      getCountries: getCountries,
      getRegions: getRegions,
    }
  },
})
